import { useState } from 'react';
import { AxiosError } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { getImagesInfo } from 'api';

export function useDownloadRealEstateReport() {
  const [loading, setLoading] = useState(false);
  const { addError } = useError();

  async function downloadFile(file: string) {
    setLoading(true);

    try {
      const [fileInfo] = await getImagesInfo([file]);
      window.open(fileInfo.downloadUrl, '_blank');
    } catch (error) {
      addError((error as AxiosError).response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  return { loading, downloadFile };
}
